// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your Firebase project settings (replace with your actual config)
const firebaseConfig = {
  apiKey: "AIzaSyA18j6cFHYHv2OU52HyB72CMo6eHYG5uLA",
  authDomain: "aecr-64f4b.firebaseapp.com",
  projectId: "aecr-64f4b",
  storageBucket: "aecr-64f4b.firebasestorage.app",
  messagingSenderId: "734626581465",
  appId: "1:734626581465:web:18e88aec7c5633389327c8",
  measurementId: "G-QR9TB5SQ6T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);




// ✅ Export auth so other files can use it
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
export const db = getFirestore(app);
export const storage = getStorage(app);
